import { useBreakpoint } from '@anchorage/hooks';
import { MobileNotSupported } from 'components/MobileNotSupported/MobileNotSupported';
import { useMobileLayout } from 'hooks/useMobileLayout/useMobileLayout';
import { useRouter } from 'next/router';
import type { ReactElement } from 'react';

// Pages that are not forms. They are informational or already responsive, so
// they keep rendering on small screens. Every other page is a questionnaire
// or certification form and is replaced by `MobileNotSupported`.
export const ALLOWED_ROUTES_FOR_MOBILE = [
  '/',
  '/404',
  '/expired',
  '/invalid',
  '/form-submitted',
];

type Props = { children: ReactElement };

// With `ONB_MOBILE_FORM` on, every route renders on every viewport. With it
// off, form pages are replaced by a "desktop only" message on mobile-sized
// viewports. While the flag is loading (`useMobileLayout` is `undefined`),
// mobile viewports render nothing so the "desktop only" screen does not flash
// before the form. Uses the Next.js route `pathname`, which has no basePath,
// so deploy-PR previews served under PATH_PREFIX need no special handling.
export const DeviceChecker = ({ children }: Props) => {
  const { pathname } = useRouter();
  const { isMobile } = useBreakpoint();
  const isMobileLayout = useMobileLayout();

  if (isMobile && !ALLOWED_ROUTES_FOR_MOBILE.includes(pathname)) {
    if (isMobileLayout === undefined) {
      return null;
    }
    if (!isMobileLayout) {
      return <MobileNotSupported />;
    }
  }

  return children;
};
